import React from 'react';

const TermsModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Términos y Condiciones de Uso</h2>
                    <button className="modal-close-button" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="modal-body">
                    <div className="terms-content">
                        <section>
                            <h3>1. Descripción del Servicio</h3>
                            <p>TransferisOK es una plataforma que permite a los comercios consultar y verificar transferencias recibidas en la cuenta de MercadoPago en tiempo real. El servicio actúa como intermediario para facilitar el acceso a los datos de transferencias sin almacenar información sensible de las mismas.</p>
                        </section>

                        <section>
                            <h3>2. Datos que Recopilamos y Almacenamos</h3>
                            <ul>
                                <li><strong>Datos del usuario registrado:</strong> Nombre completo, correo electrónico</li>
                                <li><strong>Datos del negocio:</strong> Nombre del negocio, DNI/CUIT, teléfono, sector de actividad, número de empleados, direcciones de sucursales</li>
                                <li><strong>Datos de uso:</strong> Información sobre cómo conoció nuestro servicio</li>
                                <li><strong>Datos de sesión:</strong> Para mantener la autenticación y seguridad</li>
                            </ul>
                        </section>

                        <section>
                            <h3>3. Datos que NO Almacenamos</h3>
                            <ul>
                                <li><strong>Información de transferencias:</strong> No guardamos ningún dato de las transferencias de MercadoPago</li>
                                <li><strong>Datos financieros:</strong> No almacenamos información bancaria, números de tarjeta, o datos de pago</li>
                                <li><strong>Información personal de clientes:</strong> No recopilamos datos de los clientes de nuestros usuarios</li>
                            </ul>
                        </section>

                        <section>
                            <h3>4. Cómo Funciona el Servicio</h3>
                            <ul>
                                <li>Realizamos llamadas directas a las APIs de MercadoPago en tiempo real</li>
                                <li>Los datos de transferencias se muestran temporalmente durante la sesión</li>
                                <li>No se almacenan registros permanentes de las transferencias consultadas</li>
                                <li>Toda la información se transmite de forma segura y encriptada</li>
                            </ul>
                        </section>

                        <section>
                            <h3>5. Seguridad de Datos</h3>
                            <ul>
                                <li>Utilizamos Firebase/Firestore de Google Cloud para almacenar datos de usuarios</li>
                                <li>Implementamos medidas de seguridad estándar de la industria</li>
                                <li>Los datos se almacenan en servidores seguros de Google Cloud</li>
                                <li>Utilizamos autenticación segura y tokens de acceso</li>
                            </ul>
                        </section>

                        <section>
                            <h3>6. Responsabilidades del Usuario</h3>
                            <ul>
                                <li>Proporcionar información veraz y actualizada</li>
                                <li>Mantener la confidencialidad de sus credenciales de acceso</li>
                                <li>Usar el servicio únicamente para fines legítimos</li>
                                <li>Cumplir con las políticas de MercadoPago y regulaciones aplicables</li>
                            </ul>
                        </section>

                        <section>
                            <h3>7. Limitaciones del Servicio</h3>
                            <ul>
                                <li>El servicio depende de la disponibilidad de las APIs de MercadoPago</li>
                                <li>No garantizamos la disponibilidad 24/7 del servicio</li>
                                <li>No somos responsables por interrupciones en el servicio de MercadoPago</li>
                                <li>Los datos mostrados son responsabilidad exclusiva de MercadoPago</li>
                            </ul>
                        </section>

                        <section>
                            <h3>8. Privacidad</h3>
                            <ul>
                                <li>No compartimos datos personales con terceros sin consentimiento</li>
                                <li>Utilizamos datos de uso para mejorar el servicio</li>
                                <li>Puede solicitar la eliminación de sus datos en cualquier momento</li>
                                <li>Cumplimos con las regulaciones de protección de datos aplicables</li>
                            </ul>
                        </section>

                        <section>
                            <h3>9. Pago y Precios del Servicio</h3>
                            <ul>
                                <li><strong>Servicio de pago:</strong> TransferisOK es un servicio de suscripción mensual</li>
                                <li><strong>Precio actual:</strong> El precio del servicio se encuentra detallado en la plataforma al momento del registro</li>
                                <li><strong>Cambios de precio:</strong> Nos reservamos el derecho de modificar los precios del servicio</li>
                                <li><strong>Notificación previa:</strong> Cualquier cambio en el precio será notificado con un mínimo de 30 días de anticipación</li>
                                <li><strong>Aceptación de cambios:</strong> El uso continuado del servicio después de la notificación implica la aceptación del nuevo precio</li>
                                <li><strong>Facturación:</strong> Los pagos se procesan de forma automática según el ciclo de facturación establecido</li>
                                <li><strong>Cancelación:</strong> Puede cancelar su suscripción en cualquier momento sin penalizaciones</li>
                            </ul>
                        </section>

                        <section>
                            <h3>10. Comunicaciones y Novedades</h3>
                            <ul>
                                <li><strong>Consentimiento:</strong> Al registrarse, acepta recibir comunicaciones sobre novedades, actualizaciones y mejoras del servicio</li>
                                <li><strong>Tipos de comunicaciones:</strong> Incluyen notificaciones sobre nuevas funcionalidades, mejoras de seguridad, cambios en los términos de servicio y otras novedades relevantes</li>
                                <li><strong>Frecuencia:</strong> Las comunicaciones se enviarán de manera ocasional y solo cuando sea necesario</li>
                                <li><strong>Canal de comunicación:</strong> Principalmente a través de correo electrónico</li>
                                <li><strong>Cancelación:</strong> Puede cancelar el envío de estas comunicaciones en cualquier momento desde su perfil o contactando nuestro soporte</li>
                                <li><strong>No spam:</strong> Nos comprometemos a no enviar comunicaciones excesivas o no solicitadas</li>
                            </ul>
                        </section>

                        <section>
                            <h3>11. Baja del Servicio</h3>
                            <ul>
                                <li><strong>Derecho de baja:</strong> El usuario puede darse de baja del servicio en cualquier momento</li>
                                <li><strong>Proceso de baja:</strong> La baja se puede realizar a través de la plataforma o contactando nuestro soporte</li>
                                <li><strong>Eliminación de datos:</strong> Al darse de baja, todos los datos personales y del negocio serán eliminados de nuestros servidores</li>
                                <li><strong>Confirmación:</strong> Se enviará una confirmación por correo electrónico una vez completada la baja</li>
                                <li><strong>Sin penalización:</strong> No hay costos adicionales ni penalizaciones por darse de baja</li>
                                <li><strong>Acceso inmediato:</strong> El acceso al servicio se suspenderá inmediatamente tras confirmar la baja</li>
                            </ul>
                        </section>

                        <section>
                            <h3>12. Modificaciones</h3>
                            <ul>
                                <li>Nos reservamos el derecho de modificar estos términos</li>
                                <li>Los cambios serán notificados a través de la plataforma</li>
                                <li>El uso continuado implica aceptación de los nuevos términos</li>
                            </ul>
                        </section>

                        <section>
                            <h3>13. Contacto</h3>
                            <p>Para consultas sobre estos términos, el servicio, facturación, solicitar la baja o cancelar comunicaciones, puede contactarnos a través de la plataforma.</p>
                        </section>

                        <div className="terms-footer">
                            <p><strong>Fecha de última actualización:</strong> {new Date().toLocaleDateString('es-AR')}</p>
                            <p><strong>Al aceptar estos términos, confirma que ha leído, comprendido y acepta todas las condiciones establecidas, incluyendo el envío de comunicaciones sobre novedades del servicio.</strong></p>
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="modal-button" onClick={onClose}>
                        Cerrar
                    </button>
                </div>
            </div>

            <style>{`
                .modal-backdrop {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                    padding: 20px;
                }

                .modal-content {
                    background: white;
                    border-radius: 12px;
                    width: 100%;
                    max-width: 800px;
                    max-height: 90vh;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
                }

                .modal-header {
                    padding: 24px 24px 16px 24px;
                    border-bottom: 1px solid #e5e7eb;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-shrink: 0;
                }

                .modal-header h2 {
                    margin: 0;
                    color: #001C4D;
                    font-size: 24px;
                    font-weight: bold;
                }

                .modal-close-button {
                    background: none;
                    border: none;
                    font-size: 32px;
                    cursor: pointer;
                    color: #6b7280;
                    padding: 0;
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    transition: background-color 0.2s;
                }

                .modal-close-button:hover {
                    background-color: #f3f4f6;
                    color: #374151;
                }

                .modal-body {
                    flex: 1;
                    overflow-y: auto;
                    padding: 0;
                }

                .terms-content {
                    padding: 24px;
                }

                .terms-content section {
                    margin-bottom: 28px;
                }

                .terms-content h3 {
                    color: #001C4D;
                    font-size: 18px;
                    font-weight: 600;
                    margin: 0 0 16px 0;
                    text-align: left;
                }

                .terms-content p {
                    color: #374151;
                    line-height: 1.7;
                    margin: 0 0 16px 0;
                    text-align: left;
                }

                .terms-content ul {
                    color: #374151;
                    line-height: 1.7;
                    margin: 0 0 16px 0;
                    padding-left: 24px;
                    text-align: left;
                }

                .terms-content li {
                    margin-bottom: 10px;
                    text-align: left;
                }

                .terms-content strong {
                    color: #001C4D;
                    font-weight: 600;
                }

                .terms-footer {
                    margin-top: 32px;
                    padding-top: 24px;
                    border-top: 1px solid #e5e7eb;
                    text-align: left;
                }

                .terms-footer p {
                    color: #6b7280;
                    font-size: 14px;
                    margin-bottom: 12px;
                    text-align: left;
                    line-height: 1.6;
                }

                .modal-footer {
                    padding: 16px 24px 24px 24px;
                    border-top: 1px solid #e5e7eb;
                    display: flex;
                    justify-content: flex-end;
                    flex-shrink: 0;
                }

                .modal-button {
                    background-color: #001C4D;
                    color: white;
                    border: none;
                    padding: 12px 24px;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: background-color 0.2s;
                }

                .modal-button:hover {
                    background-color: #002a5c;
                }

                @media (max-width: 768px) {
                    .modal-backdrop {
                        padding: 10px;
                    }

                    .modal-content {
                        max-height: 95vh;
                    }

                    .modal-header {
                        padding: 20px 20px 16px 20px;
                    }

                    .modal-header h2 {
                        font-size: 20px;
                    }

                    .terms-content {
                        padding: 20px;
                    }

                    .terms-content h3 {
                        font-size: 16px;
                    }

                    .terms-content ul {
                        padding-left: 20px;
                    }

                    .modal-footer {
                        padding: 16px 20px 20px 20px;
                    }
                }
            `}</style>
        </div>
    );
};

export default TermsModal;